import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminSidebar from "../../../components/admin/AdminSidebar";
import AdminDashboard from "../dashboard/AdminDashboard";
import AdminAccess from "../admin-access/AdminAccess";
import AdminStudentAccess from "../student-access/StudentAccess";
import AdminTeacherAccess from "../teacher-access/TeacherAccess";
import Error404 from "../../errors/Error404";

const AdminContainer = () => {
  return (
    <>
      <div className="flex flex-row">
        <div className="h-screen sticky top-0 left-0 hidden lg:flex">
          <AdminSidebar />
        </div>
        <Routes>
          <Route
            path="dashboard"
            element={<AdminDashboard tabTitle="Project Hub" />}
          />
          <Route
            path="student-access"
            element={<AdminStudentAccess tabTitle="Project Hub" />}
          />
          <Route
            path="teacher-access"
            element={<AdminTeacherAccess tabTitle="Project Hub" />}
          />
          <Route
            path="admin-access"
            element={<AdminAccess tabTitle="Project Hub" />}
          />
          <Route
            path="*"
            element={<Error404 tabTitle="404 Page Not Found" />}
          />
        </Routes>
      </div>
    </>
  );
};

export default AdminContainer;
